import filtersConstants from "store/features/forms/forms.constants";
import { createAsyncAction } from "typesafe-actions";
import { FormSchema } from "api/factories/form.factory";

const { FETCH_FORM_SCHEMA_REQUEST, FETCH_FORM_SCHEMA_SUCCESS, FETCH_FORM_SCHEMA_FAILED } = filtersConstants;

export const fetchSchema = createAsyncAction(
    FETCH_FORM_SCHEMA_REQUEST,
    FETCH_FORM_SCHEMA_SUCCESS,
    FETCH_FORM_SCHEMA_FAILED
)<{ key: string; matspec: number; admaterial: number; language: string }, { schema: FormSchema[] }, ErrorHandler>();
